import { useClients as useClientsApi } from 'api/requests';
import { PermissionType } from 'api/types/entity';
import { useQueryListData } from 'hooks';
import { ROUTES, generatePath } from 'libs/navigation';
import { usePermissions } from 'libs/permissions';
import { TableSetRowHref } from 'libs/ui';

import { ClientsListItem } from '../types';

const LIMIT = 50;

export const useClients = () => {
  const {
    list: clients,
    rowCount,
    loading,
    setFilter,
    sort,
    page,
    filter,
    onPaginationChange,
    onSortChange,
  } = useQueryListData(useClientsApi, {
    limit: LIMIT,
    filterParams: [
      'search',
      'onboardingStatuses',
      'riskLevels',
      'locationCountries',
      'registrationCountries',
    ],
    filterParsers: {
      search: (value) => value,
    },
  });

  const { checkPermissions } = usePermissions();

  const setRowHref: TableSetRowHref<ClientsListItem> | undefined =
    checkPermissions([PermissionType.Client_LegalClient_GetOne])
      ? (client) =>
          generatePath(ROUTES.clients.personClients.personClient.fullPath, {
            clientId: client.id,
          })
      : undefined;

  return {
    clients,
    loading,
    sort,
    page,
    rowCount,
    limit: LIMIT,
    filter,
    setFilter,
    setRowHref,
    onSortChange,
    onPaginationChange,
  };
};
